// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__C3e02","productName":"Table_productName__2Ek4p"};